export const jidsNRCForms_NRCDowntime = [
  'California',
  'Colorado',
  'Connecticut',
  'Florida',
  'Georgia',
  'Indiana',
  'Kentucky',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Nebraska',
  'New Jersey',
  'New York',
  'North Carolina',
  'Oregon',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
];
export const dispatchStatusOptions = ['Down', 'Up'];
export const dispositionOptions = ['Dispatch', 'One-N-Done'];
